<main class="what-plaster">
  <div class="container">
    <div class="row">
      <div class="col- col-md-4 col-xs-12 couple circle d-none d-sm-block padding-left-0">
        <img src="assets/foto3.jpg" class="main-bg img-fluid" />
      </div>
      <div class="col col-md-5 col-xs-12 right-border-white">
    <article class="description">

      <h1><b>JAKI RODZAJ</b> TYNKU?</h1>
      <p>
          Zadaniem tynku na elewację jest nie tylko ozdobienie fasady domu, ale również
          zabezpieczenie jej przed niekorzystnym wpływem czynników atmosferycznych
          i otoczenia. Tynki różnią się składem i właściwościami, dlatego wybierając rodzaj
          tynku należy wziąć pod uwagę materiał zastosowany do ocieplenia domu,
          usytuowanie budynku oraz efekt dekoracyjny, jaki chcesz uzyskać.</p>
      <h3>Wybierz rodzaj tynku <br>na elewację swojego domu</h3>
      <h3>Pomożemy Ci dokonać najlepszego wyboru!</h3>
      <br/><p>
          Odpowiedz na kilka prostych pytań, a podpowiemy Ci, jaki
          rodzaj tynku będzie najlepszy na elewację Twojego domu.
      </p>
    </article>
      </div>
      <div class="col- col-lg-3 col-md-3 col-xs-12">
    <aside>
      <h4>Tutaj jesteś</h4>
      <!-- Vertical Steppers -->



      <!-- /.Vertical Steppers -->
      <ol>
        <li>Wybór domu</li>
        <li>Wybór kolorów</li>
        <li class="selected">Wybór tynku</li>
        <li>Kalkulator zużycia</li>
        <li>Wybór sklepu</li>
      </ol>
    </aside>
  </div>
  </div>
  </div>
</main>
<app-footer [next]="next" [prev]="prev"></app-footer>
